<template>
    <a-layout class="body-content">
        <a-layout-sider v-model:collapsed="collapsed" theme="light" :style="{ overflow: 'auto'}" :trigger="null" collapsible>
            <div class="logo"> <img class="img" src="../assets/images/logo.png" alt=""> </div>
            <Sidebar />
        </a-layout-sider>
        <a-layout>
            <a-layout-header style="background: #fff; padding: 0">
                <a-row justify="space-between">
                    <a-col style="display:flex;">
                        <menu-unfold-outlined v-if="collapsed" class="trigger" @click="() => (collapsed = !collapsed)" />
                        <menu-fold-outlined v-else class="trigger" @click="() => (collapsed = !collapsed)" />
                        <a-breadcrumb style="display:flex; align-items:center ">
                            <a-breadcrumb-item v-for="(item, index) in breadList" :key="item.name">
                                <router-link
                                    v-if="index != 0 && index != breadList.length-1 "
                                    :to="{ path: item.path === '' ? '/' : item.path }"
                                >{{ item.meta.title }}</router-link>
                                <span v-else>{{ item.meta.title }}</span>
                            </a-breadcrumb-item>
                        </a-breadcrumb>
                    </a-col>
                    <a-col>
                        <Navibar />
                    </a-col>
                </a-row>
            </a-layout-header>
            <a-layout-content class="main-content">
                <router-view :key="route.fullPath" />
            </a-layout-content>
        </a-layout>
    </a-layout>
</template>
<script>
import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons-vue";
import { ref,watch } from "vue";
import Navibar from "./Navibar.vue";
import Sidebar from "./Sidebar.vue";
import { useRoute, useRouter } from "vue-router";
import { MainRoute } from "../router";
import { STORE_KEY_ADMIN_ROUTE, GetLocalStorageT } from "@/utils/storage";
import { FilterRouters } from "@/utils/utils";
import { GlobalMessage } from "@/utils/message";

export default {
    components: {
        MenuUnfoldOutlined,
        MenuFoldOutlined,
        Navibar,
        Sidebar,
    },
    setup() {
        const router = useRouter();
        const route = useRoute();
        let myroutes = GetLocalStorageT(STORE_KEY_ADMIN_ROUTE);
        if(myroutes == undefined || myroutes == null || (Array.isArray(myroutes) && myroutes.length == 0)) {
            GlobalMessage.error('数据错误，请重新登录');
            router.replace('/logout');
            router.go(0);
        }
        FilterRouters(router.options.routes, myroutes);
        
        const breadList = ref([]);
        let bgColor = ref('');
        // 获取面包屑数据
        const getBreadcrumb = () => {
            breadList.value.length = 0;
            route.matched.forEach(item => {
                breadList.value.push(item);
            });
        };
        getBreadcrumb();
        watch(() => route.name, () => {
            getBreadcrumb();
        });
        return {
            selectedKeys: ref(["1"]),
            collapsed: ref(false),
            bgColor,
            MainRoute,
            breadList,
            getBreadcrumb,
            route
        };
    },
};
</script>
<style scoped>
#app,.body-content {
    height: 100%;
}
.ant-input {
    height: 32px;
}
.main-content {
    overflow: auto;
    margin-left: 20px;
    margin-top: 20px;
    background-color: #FFF;
    padding: 20px;
}
.logo{
    height: 64px;
    padding: 15px;
}
.logo img {
    height: 100%;
}
::-webkit-scrollbar {
    width: 3px;
}
</style>
